import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';
import clsx from 'clsx';
import { ComponentType } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ROUTES } from 'src/constants/routes';
import { useAuth } from '../../../hooks';
import { LogoOneId } from '../../icons';
import useStyles from './styles';

interface AuthOneIdProps {
  className?: string;
}

export const AuthOneId: ComponentType<AuthOneIdProps> = ({ className }) => {
  const classes = useStyles();
  const { isLoading, handleAuthViaSSO, isAuthorized } = useAuth();
  const { t } = useTranslation();

  if (isAuthorized)
    return (
      <>
        <Button
          className={clsx(classes.root, className)}
          size="large"
          variant="contained"
          href={ROUTES.CABINET}
          color="inherit"
        >
          {t('loginCabinet', 'Войти в кабинет')}
        </Button>
      </>
    );

  return (
    <>
      <LoadingButton
        onClick={handleAuthViaSSO}
        className={clsx(classes.root, className)}
        size="large"
        variant="contained"
        loading={isLoading}
        color="inherit"
        sx={{}}
      >
        <Trans i18nKey="loginWith" components={{ logo: <LogoOneId /> }} />
      </LoadingButton>
    </>
  );
};
